import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  updateOpponentPlayer,
  deleteOppPlayer,
} from "../../../services/player.services.js";
import ErrorOverlay from "../../../UserComponents/overlays/ErrorOverlay.js";
import PositionsListOverlay from "../../../UserComponents/modals/PositionsList.js";


const initialState = {
  playerId: '',
  playerName: '',
  firstName: '',
  lastName: '',
  playerNumber: '',
  isCaptain: false,
  position: '',
};

const EditOppPlayerOverlay = (props) => {
  const user = useSelector((state) => state.auth.user);
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingDel, setLoadingDel] = useState(false);
  const [pos1Visible, setPos1Visible] = useState(false);
  const [pos2Visible, setPos2Visible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };
      // update playerName with firstName and lastName
      if (name === 'firstName' || name === 'lastName') {
        updatedState.playerName = `${updatedState.firstName} ${updatedState.lastName}`.trim();
      }
      return updatedState;
    });
  };
  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    props.handleGetPlayers();
    setTimeout(() => {
      props.onBackdropPress();
      setSuccessVisible(false);
    }, 2500);
  };

  const togglePosition1 = () => {
    setPos1Visible(!pos1Visible);
  };
  useEffect(() => {
    handleFormChange('playerId', props.playerId);
    // handleFormChange('playerName', props.data?.playerName);
    handleFormChange('firstName', props.data?.firstName);
    handleFormChange('lastName', props.data?.lastName);
    handleFormChange('playerNumber', props.data?.playerNumber);
    handleFormChange('position', props.data?.position || '');
  }, []);

  const handleUpdate = async () => {
    try {
      setLoadingEdit(true);
      const response = await updateOpponentPlayer(
        initialStateForm,
        user?.token,
      );
      await props.handleGetPlayers();
      props.onBackdropPress();
    } catch (e) {
      setError(e);
      console.log('errorrrrrrr in updateOpponentPlayer =>> ', e.response);
    } finally {
      setLoadingEdit(false);
    }
  };


  const handleDelete = async () => {
    try {
      setLoadingDel(true);
      await deleteOppPlayer(props.data._id, user?.token);
      toggleSuccessModal();
    } catch (e) {
      setError(e);
    } finally {
      setLoadingDel(false);
    }
  };

  return (
    <div
      className={`modal ${props.isVisible ? "show" : ""}`}
      onClick={props.onBackdropPress}
    >
      {error && (
        <ErrorOverlay
          onBackdropPress={() => setError(null)}
          visible={!!error}
          error={error}
        />
      )}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="">EDIT OPPONENT PLAYER</h2>
        </div>
        <div className="modal-body">
          <label className="checkbox-container full">
            Captain
            <input
              type="checkbox"
              checked={initialStateForm.isCaptain}
              onChange={() =>
                handleFormChange("isCaptain", !initialStateForm.isCaptain)
              }
            />
          </label>
          {/* <div className="field-group">
            <label className="mainLabel">Name:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.playerName}
              onChange={(e) => handleFormChange("playerName", e.target.value)}
            />
          </div> */}
          <div className="field-group">
            <label className="mainLabel">First Name:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.firstName}
              onChange={(e) => handleFormChange("firstName", e.target.value)}
            />
          </div>
          <div className="field-group">
            <label className="mainLabel">Last Name:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.lastName}
              onChange={(e) => handleFormChange("lastName", e.target.value)}
            />
          </div>
          <div className="field-group">
            <label className="mainLabel">Jersey #:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.playerNumber}
              onChange={(e) => handleFormChange("playerNumber", e.target.value)}
            />
          </div>
          <div className="field-group">
            <label className="mainLabel">Position:</label>
            <input
              className="input-field"
              type="text"
              value={initialStateForm.position}
              readOnly
              onClick={togglePosition1}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={handleDelete}>
            {loadingDel ? "Deleting..." : "Delete Player"}
          </button>
          <button className="btn-primary" onClick={handleUpdate}>
            {loadingEdit ? "Saving..." : "Save"}
          </button>
        </div>

        <PositionsListOverlay
          onBackdropClick={togglePosition1}
          setPosition={(text) => handleFormChange("position", text)}
          visible={pos1Visible}
        />


      </div>
    </div>
  );
};

export default EditOppPlayerOverlay;
